import { render, staticRenderFns } from "./TabEnterExit.vue?vue&type=template&id=40585f50&scoped=true&"
import script from "./TabEnterExit.vue?vue&type=script&lang=ts&"
export * from "./TabEnterExit.vue?vue&type=script&lang=ts&"
import style0 from "./TabEnterExit.vue?vue&type=style&index=0&id=40585f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40585f50",
  null
  
)

component.options.__file = "TabEnterExit.vue"
export default component.exports